<!--
 * @Author: 汪俊洪
 * @Date: 2025-06-04 14:33:54
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-04 15:31:17
 * @Description:
-->
<template>
  <div class="wrap">
    <div class="content">
      <h2 class="title">核心功能亮点</h2>
      <div class="sub-title">一站式解决工程服务管理难题</div>
      <div class="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="`item item${index + 1}`"
        >
          <h3 class="item-title">{{item.title}}</h3>
          <div v-for="(item2, index2) in item.item" :key="index2">
            <h3 class="item-sub-title">{{ item2.title }}</h3>
            <div class="item-des">
              {{ item2.des }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          title: '生态伙伴全生命周期管理',
          item: [
            {
              title: '便捷入驻',
              des: '通过 宁东工业超市 平台提交企业资质、人员信息等资料，快速完成账号注册与审批'
            },
            {
              title: '标签管理',
              des: '自主申请行业标签（如化工工程、自动化安装等）与能力标签（如技术研发、施工运维等），经官方审核后同步至企业档案，提升曝光度'
            },
            {
              title: '动态更新',
              des: '实时维护企业信息、人员资质及服务案例，确保资源库数据鲜活可靠'
            }
          ]
        },
        {
          title: '智能化任务协作体系',
          item: [
            {
              title: '需求精准触达',
              des: '生态合作管理部定期发布服务需求公告（如项目实施等），生态伙伴可根据行业/能力要求盘点内部资源情况、主动接单'
            },
            {
              title: '全流程可视化',
              des: '从接单、报工、服务单据回传到结算、评价，通过平台实时追踪任务状态，支持短信预警与数据复盘'
            },
            {
              title: '高效结算流程',
              des: '服务完成后点击报工清单一键生成结算单，线上审批与评价一键完成，缩短回款周期'
            }
          ]
        },
        {
          title: '数据驱动的生态资源库',
          item: [
            {
              title: '多维度标签体系',
              des: '通过行业、能力、区域等标签精准分类，快速定位合作伙伴'
            },
            {
              title: '资源看板可视化',
              des: '实时展示生态资源分布、任务完成率、接单活跃度、生态伙伴绩效等数据，辅助管理决策'
            },
            {
              title: '合规风险管控',
              des: '所有生态伙伴均通过产品认证，保障合作安全可靠'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 40px 0 120px;
  height: 1080px;
  background: url(~@/assets/img/ecology/bg.png) no-repeat center;
  .content {
    width: 1200px;
    margin: 0 auto;
  }
  .title {
    font-size: 40px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin: 0 0 0;
    line-height: 49px;
  }
  .sub-title {
    font-size: 20px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    color: #fff;
    line-height: 27px;
    padding: 10px 0 20px;
  }
}
.list {
  display: flex;
  justify-content: space-between;
  .item {
    display: flex;
    flex-direction: column;
    width: 374px;
    height: 814px;
    border-radius: 8px;
    background: linear-gradient(
      180deg,
      #cfe0fa 0%,
      #cfdffa 17%,
      rgba(206, 223, 250, 0) 27%
    );
    background-color: #fff;
    padding: 40px 40px 20px;
    &.item2 {
      background: linear-gradient(
        180deg,
        #ceeff8 0%,
        #ceeff8 17%,
        rgba(206, 239, 248, 0) 27%
      );
      background-color: #fff;
      .item-title {
        color: #26829b;
      }
    }
    &.item3 {
      background: linear-gradient(
        180deg,
        #e2def5 0%,
        #e1def4 17%,
        rgba(226, 222, 245, 0) 27%
      );
      background-color: #fff;
      .item-title {
        color: #482ec7;
      }
    }
    > div {
      height: 196px;
    }
    .item-title {
      font-size: 24px;
      font-weight: bold;
      line-height: 30px;
      color: #2a54d1;
      margin: 0;
      flex: 1;
    }
    .item-sub-title {
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
      color: rgba(0, 0, 0, 0.8);
      padding: 0 0 8px;
      margin: 0;
    }
    .item-des {
      font-size: 18px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
